import React, { PropsWithChildren } from 'react';

import { bemHelper } from '../../../helpers';

export interface BaseTableHeadRowProps {
  /** Modifier for sticker headers */
  sticky?: boolean;
}

export interface TableHeadRowProps extends PropsWithChildren<BaseTableHeadRowProps> {}

function TableHeadRow(props: TableHeadRowProps) {
  const defineClassName = (): string => {
    const b = bemHelper();

    return b('ink-table--head--row', {
      sticky: props.sticky,
    });
  };

  return (
    <thead>
      <tr className={defineClassName()}>{props.children}</tr>
    </thead>
  );
}

TableHeadRow.defaultProps = {
  sticky: false,
};

export default TableHeadRow;
